export interface MenuItem {
  group?: string;
  separator?: boolean;
  selected?: boolean;
  active?: boolean;
  items: Array<SubMenuItem>;
}

export interface SubMenuItem {
  icon?: string;
  label?: string;
  route?: string | null;
  expanded?: boolean;
  active?: boolean;
  disable?: boolean;
  children?: Array<SubMenuItem>;
}

export class Menu {
  public static pages: MenuItem[] = [
    {
      group: 'main',
      separator: false,
      items: [
        {
          icon: 'icons/base/dashboard.svg',
          label: 'dashboard',
          route: './dashboard',
        },
        // {
        //   icon: 'icons/base/users.svg',
        //   label: 'users',
        //   route: './users',
        // },

        // {
        //   icon: 'icons/base/calendar.svg',
        //   label: 'Events',
        //   route: 'events'
        // },

        // {
        //   icon: 'icons/base/sponsors.svg',
        //   label: 'Sponsors',
        //   route: './sponsors',
        // },

        // {
        //   icon: 'icons/base/pages.svg',
        //   label: 'pages',
        //   route: './pages',
        // },


        // {
        //   icon: 'icons/base/advertising-copy.svg',
        //   label: 'templates',
        //   route: './white-label-templates'
        // },

      ],

    },
    {
      group: 'stream_monetization',
      separator: false,
      items:[
          // {
          //   label: 'stickers',
          //   icon: 'icons/base/sticker.svg',
          //   route: '/admin/widgets/stickers-dashboard',
          // },

          {
            icon: 'icons/base/settings.svg',
            label: 'donation_settings',
            route: '/admin/donation-settings',
          },
          {
            label: 'donation_configurations',
            icon: 'icons/base/notification.svg',
            route: '/admin/widgets/notifications-dashboard',
          },

          {
            label: 'goal',
            icon: 'icons/base/goal.svg',
            route: '/admin/widgets/crowdfunding-dashboard',
          },
          {
            label: 'challenges',
            icon: 'icons/base/challenge.svg',
            route: '/admin/widgets/task-offer'
          },
          // {
          //   label: 'leaderboard',
          //   route: '/admin/widgets/leaderboard-dashboard',
          // },
          // {
          //   label: 'sponsors',
          //   route: '/admin/widgets/sponsor-dashboard',
          // },
    //     ]
    // },
    // // {
    // //   group: 'Shop',
    // //   separator: false,
    // //   items:[
    // //     {
    // //       label: 'products_and_services',
    // //       route: './products',
    // //     },
    // //     // {
    // //     //   label: 'crowdfunding',
    // //     //   route: '/admin/widgets/crowdfunding-dashboard',
    // //     // },
    // //     // {
    // //     //   label: 'leaderboard',
    // //     //   route: '/admin/widgets/leaderboard-dashboard',
    // //     // },
    // //     // {
    // //     //   label: 'sponsors',
    // //     //   route: '/admin/widgets/sponsor-dashboard',
    // //     // },
      ]
    },
    {

      group: 'history',
      separator: false,
      items: [

        {
          label: 'donations',
          icon: 'icons/base/donation.svg',
          route: '/admin/widgets/donations-list',
        },
        // {
        //   icon: 'icons/base/orders.svg',
        //   label: 'orders',
        //   route: './orders',
        // },
        {

          label: 'transactions',
          icon: 'icons/base/transactions.svg',
          route: './transactions',
        },
      ]
    },
    {
      group: 'settings',
      separator: false,
      items: [

        // {
        //   icon: 'icons/base/tutorials.svg',
        //   label: 'tutorials',
        //   route: './tutorials',
        // },
        {
          icon: 'icons/base/settings.svg',
          label: 'platform_settings',
          route: './settings',
        },
        // {
        //   icon: 'icons/base/web-design.svg',
        //   label: 'platform_design',
        //   route: '/page-builder',
        // },

      ],
    },
  ];
}
